// extracted by mini-css-extract-plugin
export var postItem = "post-item-list-module--post-item--f0e2c";
export var postItemContent = "post-item-list-module--post-item-content--52e55";
export var postItemDate = "post-item-list-module--post-item-date--8be7b";
export var postItemList = "post-item-list-module--post-item-list--9f8d8";
export var postItemThumbnail = "post-item-list-module--post-item-thumbnail--0bb31";
export var postItemThumbnailBox = "post-item-list-module--post-item-thumbnail-box--9bd4e";
export var postItemTitle = "post-item-list-module--post-item-title--d2f49";
export var sublink = "post-item-list-module--sublink--7e95d";
export var sublinks = "post-item-list-module--sublinks--23a47";